



























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { isWithinInterval, isValid, isBefore, endOfDay } from 'date-fns';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { Photo } from '@/models/photo';
import { Video } from '@/models/video';
import { TimelapseConfiguration } from '@/models/timelapseconfiguration';
import { TimelapseConfigurationUpdateRequest } from '@/services/projects/projects.interfaces';
import { Crop, Position } from '@/models/enums';
import TimelapsePreview from '@/components/timelapsepreview/timelapsepreview.component.vue';
import TimelapseFilter from '@/components/timelapsefilter/timelapsefilter.component.vue';
import TimelapseExclusion from '@/components/timelapseexclusion/timelapseexclusion.component.vue';
import TimelapsePhoto from '@/components/timelapsephoto/timelapsephoto.component.vue';
import TimelapseSettings from '@/components/timelapsesettings/timelapsesettings.component.vue';
import ScenarioModal from '@/components/scenariomodal/scenariomodal.component.vue';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import { NotificationMessage, Socket } from '@/store/types';
import { Logger } from 'aws-amplify';
import AWS from 'aws-sdk';
import { Auth } from 'aws-amplify';
const logger = new Logger('Timelapse');

async function configureAWSCredentials() {
  try {
    const credentials = await Auth.currentCredentials();
    AWS.config.update({
      credentials: credentials,
      region: 'eu-west-3', // Remplacez par votre région AWS
    });
    console.log('AWS Credentials configurés avec succès.');
  } catch (error) {
    console.error('Erreur lors de la configuration des credentials AWS:', error);
  }
}

@Component({
  components: {
    TimelapsePreview,
    TimelapseFilter,
    TimelapseExclusion,
    TimelapsePhoto,
    TimelapseSettings,
    ScenarioModal,
    vTeleport,
  },
})
export default class Timelapse extends Vue {
  @Prop(String) private id!: string;

  @State('projects', { namespace: 'projects' }) private projects!: Project[];
  @Getter('projectWithId', { namespace: 'projects' }) private projectWithId!: (id: string) => Project;

  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;
  @State('timelapse', { namespace: 'project' }) private timelapse!: Video[];
  @State('loadingTimelapse', { namespace: 'project' }) private loadingTimelapse!: boolean;
  @Getter('timelapseForCamera', { namespace: 'project' }) private timelapseForCamera!: (cameraId: string) => Video;
  @Action('setProject', { namespace: 'project' }) private setProject!: (project: Project) => Promise<void>;
  @Action('loadTimelapse', { namespace: 'project' }) private loadTimelapse!: () => Promise<void>;
  @Action('saveTimelapseConfiguration', { namespace: 'project' }) private saveTimelapseConfiguration!: (
    config: TimelapseConfigurationUpdateRequest
  ) => Promise<void>;

  @Action('findAllFor', { namespace: 'photo' }) private findPhotoAllForProject!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Photo[]>;

  @State('socket') private socketMessage!: Socket;
  @State('photosByCameraId', { namespace: 'photo' }) private readonly photosByCameraId!: {
    [cameraId: string]: Photo[];
  };
  @Action('connectSocket') private connectSocket!: () => Promise<void>;
  @Action('disconnectSocket') private disconnectSocket!: () => Promise<void>;
  @Mutation('SOCKET_ONMESSAGE') private resetSocketMessage!: (object: string) => void;

  private project: Project | null = null;
  private lastVideo: Video | null = null;
  private timelapseRending = false;
  private leftPanelVisible = true;
  private logoUrl: string | null = null;
  private showLogoActions = false;

  private imagesKey: Photo[] = [];

  private defaultImageModifier = {
    iso: 0,
    brightness: 0,
    contrast: 0,
    saturation: 0,
    white: 0,
    crop: Crop.original,
    erigeWatermark: true,
    watermarkPosition: Position.bottomright,
  };

  private get defaultConfig(): TimelapseConfiguration {
    return {
      ...this.defaultImageModifier,
      interval: {
        begin: NaN,
        end: NaN,
      },
      lastNDays: false,
      lastNDaysSpan: 30,
      period: {
        startHour: '00:00',
        endHour: '23:59',
      },
      exclude: [],
      days: [0, 1, 2, 3, 4, 5, 6],
      fps: 25,
      hdr: false,
      blue: [0, 6],
      gain: [this.camera?.isTikee ? 40 : 0, this.camera?.isTikee ? 1800 : 24],
      exposure: [0, this.camera?.isTikee ? 250 : 1000],
      clearness: [0, this.camera?.isTikee ? 60 : 40],
      person: [0, this.camera?.isTikee ? 100 : 100],
      movement: [0, 100],
      goutte: [0, 100],
      photoExclusion: [] as string[],
      slowmotion: true,
    };
  }

  private config: TimelapseConfiguration | null = null;

  public get breadcrumbs(): unknown[] {
    const items = [
      {
        text: this.$tc('global.project', 2),
        to: '/',
      },
    ];
    if (this.project !== null) {
      items.push({
        text: this.project.name,
        to: '/project/' + this.project.id,
      });
    }
    items.push({
      text: this.$tc('global.timelapse'),
      to: '#',
    });
    return items;
  }

  resizing = false;

  startResize(event: MouseEvent) {
    this.resizing = true;
    window.addEventListener('mousemove', this.performResize);
    window.addEventListener('mouseup', this.stopResize);
  }

  performResize(event: MouseEvent) {
    if (this.resizing) {
      const leftElement = this.$el.querySelector('.left-film') as HTMLElement;
      if (leftElement !== null) {
        const newWidth = event.clientX - leftElement.getBoundingClientRect().left;
        leftElement.style.width = `${newWidth}px`;
      }
    }
  }

  stopResize() {
    if (this.resizing) {
      this.resizing = false;
      window.removeEventListener('mousemove', this.performResize);
      window.removeEventListener('mouseup', this.stopResize);
    }
  }

  public toggleLeftPanel() {
    console.log('toggleLeftPanel called');
    this.leftPanelVisible = !this.leftPanelVisible;
  }

  public get timelapseGridStyle() {
    if (this.lastVideo) {
      return {
        'grid-template-areas':
          "'timelapse-filter-film timelapse-photos-film timelapse-photos-film' 'timelapse-preview-film timelapse-photos-film timelapse-photos-film'",
      };
    } else {
      return {
        'grid-template-areas':
          "'timelapse-filter-film timelapse-photos-film timelapse-photos-film' 'timelapse-filter-film timelapse-photos-film timelapse-photos-film'",
      };
    }
  }

  public get cameraSelected(): string | null {
    return (this.$route.query.camera as string) || null;
  }
  public set cameraSelected(s: string | null) {
    logger.info('set cameraSelected', s);
    if (s !== null) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, camera: s } });
    }
  }

  public get camera(): Camera | undefined {
    logger.info('get camera ' + this.cameraSelected);
    return (
      this.project?.cameras?.find((camera: Camera) => camera.id === this.cameraSelected) ||
      this.project?.previousCameras?.find((camera: Camera) => camera.id === this.cameraSelected)
    );
  }

  private get dataImagesKey() {
    const cameraId = this.cameraSelected;

    console.log('photosByCameraId:', this.photosByCameraId);
    console.log('cameraSelected:', cameraId);
    if (cameraId && this.photosByCameraId[cameraId]) {
      console.log('Nombre de photos brutes pour cette caméra:', this.photosByCameraId[cameraId].length);
    }

    logger.info('dataImagesKey - cameraId:', cameraId);
    logger.info('dataImagesKey - photosByCameraId:', this.photosByCameraId);

    // Vérifiez si une caméra est sélectionnée et si des photos existent pour cette caméra
    if (!cameraId || !this.photosByCameraId[cameraId]) {
      logger.warn('Aucune photo trouvée pour la caméra sélectionnée.');
      return [];
    }

    let photos = this.photosByCameraId[cameraId];
    logger.info(`Nombre de photos avant filtrage: ${photos.length}`);

    // Appliquez les filtres si la configuration est présente
    if (this.config !== null) {
      const localConfig = { ...this.config };
      photos = photos.filter((item: Photo) => {
        let pass = true;

        // Filtrer par date
        if (!isNaN(localConfig.interval.begin) && !isNaN(localConfig.interval.end)) {
          const start = new Date(localConfig.interval.begin * 1000);
          const end = new Date(localConfig.interval.end * 1000);
          if (localConfig.interval.begin && localConfig.interval.end && isBefore(start, end)) {
            if (!isWithinInterval(new Date(item.createdAt), { start, end })) {
              logger.debug(`Photo ${item.id} filtrée par date.`);
              pass = false;
            }
          }
        }

        // Filtrer par slowmotion
        if (localConfig.slowmotion === false && item.isSlowmotion === true) {
          logger.debug(`Photo ${item.id} filtrée par slowmotion.`);
          pass = false;
        }

        // Filtrer par jours
        const day = new Date(item.createdAt).getDay();
        if (!localConfig.days.includes(day)) {
          logger.debug(`Photo ${item.id} filtrée par jour.`);
          pass = false;
        }

        // Filtrer par heures
        const date = new Date(item.createdAt);
        const mindate = new Date(date);
        const maxdate = new Date(date);
        if (localConfig.period.startHour) {
          mindate.setHours(
            parseInt(localConfig.period.startHour.split(':')[0] || '0', 10),
            parseInt(localConfig.period.startHour.split(':')[1] || '0', 10)
          );
        }
        if (localConfig.period.endHour) {
          maxdate.setHours(
            parseInt(localConfig.period.endHour.split(':')[0] || '0', 10),
            parseInt(localConfig.period.endHour.split(':')[1] || '0', 10)
          );
        }
        if (isValid(date) && isValid(mindate) && isValid(maxdate)) {
          try {
            if (!isWithinInterval(date, { start: mindate, end: maxdate })) {
              logger.debug(`Photo ${item.id} filtrée par intervalle horaire.`);
              pass = false;
            }
          } catch (err) {
            // Begin is after end
            logger.debug(`Photo ${item.id} filtrée par exception d'intervalle horaire.`);
            pass = false;
          }
        }

        // Filtrer par heures exclues
        if (localConfig.exclude && localConfig.exclude.length > 0) {
          const exclusion = localConfig.exclude[0];
          const excludeStart = new Date(date);
          const excludeEnd = new Date(date);
          excludeStart.setHours(
            parseInt(exclusion.startHour.split(':')[0] || '0', 10),
            parseInt(exclusion.startHour.split(':')[1] || '0', 10)
          );
          excludeEnd.setHours(
            parseInt(exclusion.endHour.split(':')[0] || '0', 10),
            parseInt(exclusion.endHour.split(':')[1] || '0', 10)
          );
          if (isValid(date) && isValid(excludeStart) && isValid(excludeEnd)) {
            try {
              if (isWithinInterval(date, { start: excludeStart, end: excludeEnd })) {
                logger.debug(`Photo ${item.id} filtrée par heures exclues.`);
                pass = false;
              }
            } catch (err) {
              // Begin is after end
              // Continue sans exclure
            }
          }
        }

        // Filtrer par exposition, gain, netteté, etc.
        if (localConfig.hdr && item.hdr !== true) {
          logger.debug(`Photo ${item.id} filtrée par HDR.`);
          pass = false;
        }
        if (Array.isArray(localConfig.exposure) && localConfig.exposure.length === 2 && item.exposure !== undefined) {
          if (item.exposure < localConfig.exposure[0] || item.exposure > localConfig.exposure[1]) {
            logger.debug(`Photo ${item.id} filtrée par exposition.`);
            pass = false;
          }
        }
        if (Array.isArray(localConfig.gain) && localConfig.gain.length === 2 && item.gainControl !== undefined) {
          if (item.gainControl < localConfig.gain[0] || item.gainControl > localConfig.gain[1]) {
            logger.debug(`Photo ${item.id} filtrée par gain.`);
            pass = false;
          }
        }
        if (
          Array.isArray(localConfig.clearness) &&
          localConfig.clearness.length === 2 &&
          item.sharpness !== undefined
        ) {
          if (item.sharpness < localConfig.clearness[0] || item.sharpness > localConfig.clearness[1]) {
            logger.debug(`Photo ${item.id} filtrée par netteté.`);
            pass = false;
          }
        }
        if (Array.isArray(localConfig.person) && localConfig.person.length === 2 && item.person !== undefined) {
          if (item.person < localConfig.person[0] || item.person > localConfig.person[1]) {
            logger.debug(`Photo ${item.id} filtrée par personne.`);
            pass = false;
          }
        }
        if (Array.isArray(localConfig.movement) && localConfig.movement.length === 2 && item.movement !== undefined) {
          if (item.movement < localConfig.movement[0] || item.movement > localConfig.movement[1]) {
            logger.debug(`Photo ${item.id} filtrée par mouvement.`);
            pass = false;
          }
        }
        if (Array.isArray(localConfig.goutte) && localConfig.goutte.length === 2 && item.goutte !== undefined) {
          if (item.goutte < localConfig.goutte[0] || item.goutte > localConfig.goutte[1]) {
            logger.debug(`Photo ${item.id} filtrée par goutte.`);
            pass = false;
          }
        }
        if (Array.isArray(localConfig.blue) && localConfig.blue.length === 2 && item.blueLevel !== undefined) {
          if (item.blueLevel < localConfig.blue[0] || item.blueLevel > localConfig.blue[1]) {
            logger.debug(`Photo ${item.id} filtrée par blueLevel.`);
            pass = false;
          }
        }

        return pass;
      });
      logger.info(`Nombre de photos après filtrage: ${photos.length}`);
    }

    // Retourner les photos filtrées sous forme d'objets avec une propriété 'data'
    return photos.map((item) => ({ data: item }));
  }

  public mounted(): void {
    logger.info('mounted');
    if (this.timelapse.length > 0) {
      this.onTimelapseLoaded(this.timelapse, []);
    }
    if (this.projects.length > 0) {
      this.onProjectsLoaded(this.projects, []);
    }
  }

  public beforeDestroy(): void {
    logger.info('beforeDestroy');
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.disconnectSocket();
  }

  private triggerLogoUpload() {
    (this.$refs.logoInput as HTMLInputElement).click();
  }

  private async handleLogoUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      console.error('❌ Aucun fichier sélectionné.');
      return;
    }

    try {
      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project?.owner?.id;
      const projectID = this.project?.id;
      if (!ownerID || !projectID) {
        console.error("❌ Impossible de récupérer l'ID du projet ou du propriétaire.");
        return;
      }

      const fileName = `logo-${Date.now()}.${file.name.split('.').pop()}`;
      const key = `public/${ownerID}/${projectID}/Logo/${fileName}`;

      const fileBuffer = await file.arrayBuffer();

      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: Buffer.from(fileBuffer),
          ContentType: file.type,
          ACL: 'public-read',
        })
        .promise();

      console.log('✅ Logo uploadé avec succès:', key);
      this.fetchLogoUrl(); // Met à jour l'affichage après upload
    } catch (error) {
      console.error("❌ Erreur lors de l'upload du logo:", error);
    }
  }

  public async fetchLogoUrl() {
    try {
      if (!this.project || !this.project.owner) {
        console.warn('❌ `project` ou `project.owner` est indéfini. Attente...');
        return;
      }

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;

      console.log('🔹 Récupération du logo pour ownerID:', ownerID, 'projectID:', projectID);

      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      const response = await s3
        .listObjectsV2({
          Bucket: 'erige-main-store-prod',
          Prefix: prefix,
        })
        .promise();

      if (response.Contents && response.Contents.length > 0) {
        const lastFile = response.Contents.sort(
          (a, b) => (b.LastModified?.getTime() || 0) - (a.LastModified?.getTime() || 0)
        )[0];

        if (lastFile && lastFile.Key) {
          this.logoUrl = s3.getSignedUrl('getObject', {
            Bucket: 'erige-main-store-prod',
            Key: lastFile.Key,
            Expires: 3600,
          });

          console.log('✅ URL du logo récupérée :', this.logoUrl);
        }
      } else {
        console.warn('❌ Aucun logo trouvé dans le bucket.');
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du logo :', error);
    }
  }

  private async deleteAllLogos() {
    try {
      if (!this.project || !this.project.owner) return;

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      // Liste des fichiers à supprimer
      const response = await s3.listObjectsV2({ Bucket: 'erige-main-store-prod', Prefix: prefix }).promise();
      if (!response.Contents || response.Contents.length === 0) {
        console.warn('❌ Aucun logo à supprimer.');
        return;
      }

      const deleteParams = {
        Bucket: 'erige-main-store-prod',
        Delete: { Objects: response.Contents.map((item) => ({ Key: item.Key! })) },
      };

      await s3.deleteObjects(deleteParams).promise();
      this.logoUrl = null; // Supprime l'affichage du logo après suppression
      console.log('✅ Tous les logos ont été supprimés.');
    } catch (error) {
      console.error('❌ Erreur lors de la suppression des logos:', error);
    }
  }

  public handleOpenScenarioModal(config: TimelapseConfiguration) {
    if (this.$refs.scenarioModal) {
      (this.$refs.scenarioModal as ScenarioModal).show(config);
    }
  }

  @Watch('projects')
  public onProjectsLoaded(val: Project[], oldVal: Project[]): void {
    logger.info('onProjectsLoaded', { val, oldVal });
    this.project = this.projectWithId(this.id);
    this.setProject(this.project);
  }

  @Watch('project')
  public async onProjectLoaded(val: Project | null, oldVal: Project | null): Promise<void> {
    logger.info('onProjectLoaded', { val, oldVal });
    if (val !== null) {
      this.onCameraSelectedChange();
    }
    await this.fetchLogoUrl();
  }

  @Watch('timelapse')
  public onTimelapseLoaded(val: Video[], oldVal: Video[]): void {
    logger.info('onTimelapseLoaded', { val, oldVal });
    if (val.length > 0 && this.cameraSelected !== null) {
      this.lastVideo = this.timelapseForCamera(this.cameraSelected);
      if (this.lastVideo?.timelapseConfiguration !== undefined) {
        const timelapseConfiguration = Object.assign({}, this.lastVideo.timelapseConfiguration);
        timelapseConfiguration.interval.end = endOfDay(timelapseConfiguration.interval.end * 1000).getTime() / 1000;
        this.config = Object.assign({ ...this.defaultConfig }, timelapseConfiguration);
      } else {
        this.config = { ...this.defaultConfig };
      }
    }
  }

  @Watch('socketMessage.message')
  public onSocketMessageChange(val: NotificationMessage): void {
    if (val.timelapse !== undefined && val.projectId === this.id && val.cameraId === this.cameraSelected) {
      switch (val.timelapse) {
        case 'ready':
          logger.info('ready');
          this.timelapseRending = false;
          this.loadTimelapse().then(() => {
            this.disconnectSocket();
          });
          break;
      }
    }
  }

  @Watch('cameraSelected')
  public onCameraSelectedChange(): void {
    logger.info('onCameraSelectedChange', { query: this.cameraSelected });
    if (this.cameraSelected !== null) {
      const indexCamera: number | undefined = this.project?.cameras
        ?.map((c: Camera) => c.id)
        .indexOf(this.cameraSelected);
      const indexPrevious: number | undefined = this.project?.previousCameras
        ?.map((c: Camera) => c.id)
        .indexOf(this.cameraSelected);
      if ((indexCamera !== undefined && indexCamera !== -1) || (indexPrevious !== undefined && indexPrevious !== -1)) {
        this.lastVideo = this.timelapseForCamera(this.cameraSelected) || null;
        this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected });
        this.lastVideo = this.timelapseForCamera(this.cameraSelected);
        if (this.lastVideo?.timelapseConfiguration !== undefined) {
          const timelapseConfiguration = JSON.parse(
            JSON.stringify(this.lastVideo.timelapseConfiguration)
          ) as TimelapseConfiguration;
          timelapseConfiguration.interval.end = endOfDay(timelapseConfiguration.interval.end * 1000).getTime() / 1000;
          this.config = Object.assign({ ...this.defaultConfig }, timelapseConfiguration);
        } else {
          this.config = { ...this.defaultConfig };
        }
      } else if (this.project?.cameras?.length ?? 0 > 0) {
        this.cameraSelected = this.project?.cameras?.[0].id ?? null;
      } else if (this.project?.previousCameras?.length ?? 0 > 0) {
        this.cameraSelected = this.project?.previousCameras?.[0].id ?? null;
      } else {
        this.cameraSelected = null;
      }
    }
  }

  @Watch('photosByCameraId')
  public onPhotoStoreUpdated(newVal: { [cameraId: string]: Photo[] }, oldVal: { [cameraId: string]: Photo[] }): void {
    logger.info('onPhotoStoreUpdated', { newVal, oldVal });
    if (this.cameraSelected && newVal[this.cameraSelected]) {
      this.imagesKey = newVal[this.cameraSelected].slice(0).sort((photo1: Photo, photo2: Photo) => {
        return photo1.createdAt.getTime() - photo2.createdAt.getTime();
      });
    } else {
      this.imagesKey = [];
    }
  }

  public save(): void {
    console.log('Vérification de this.config:', this.config);
    if (this.camera !== undefined && this.project !== null && this.config !== null) {
      const timelapseConfiguration = Object.assign({}, this.config);
      timelapseConfiguration.interval.end = endOfDay(timelapseConfiguration.interval.end * 1000).getTime() / 1000;
      this.saveTimelapseConfiguration({
        cameraId: this.camera.id,
        projectId: this.project.id,
        timelapseConfiguration,
      });
      this.resetSocketMessage('');
      this.timelapseRending = true;
      this.connectSocket();
    }
  }
}
